import gql from 'graphql-tag';
export default gql`
  mutation saveDrivingLicense($applicationId: String!, $params: [FileObject], $applicantType: String) {
    saveDrivingLicense(applicationId: $applicationId, params: $params, applicantType: $applicantType) {
      status
    }
  }
`;
